// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import visitStopEntity from './entities/visit-stop.json';
import visitStopMenu from '../pages/visit-stop/menu.json';
import visitStopFullForm from '../pages/visit-stop/forms/full.json';
import visitStopContextForm from '../pages/visit-stop/forms/context.json';
import visitStopMiniForm from '../pages/visit-stop/forms/mini.json';
import visitStopLookupForm from '../pages/visit-stop/forms/lookup.json';
import visitStopTableView from '../pages/visit-stop/views/table.json';
import visitStopCardsView from '../pages/visit-stop/views/cards.json';
import visitStopCalendarView from '../pages/visit-stop/views/calendar.json';
import visitStopDashboardView from '../pages/visit-stop/views/dashboard.json';

/** Тип запису «Зупинка візиту» зі сторінками пакета: меню, форми та подання з pages/visit-stop/. */
export const visitStopDefinition: IRecordTypeDefinition = {
  ...visitStopEntity,
  views: assembleViewSet({
      table: visitStopTableView,
      cards: visitStopCardsView,
      calendar: visitStopCalendarView,
      dashboard: visitStopDashboardView,
  }),
  form: visitStopFullForm,
  forms: { full: visitStopFullForm, context: visitStopContextForm, mini: visitStopMiniForm, lookup: visitStopLookupForm },
  menu: visitStopMenu,
} as IRecordTypeDefinition;
